export default __webpack_public_path__ + "static/media/Lustra-Startup_rocket_DAO.e88720e2.svg";